import React from "react";
import { Link } from "react-router-dom";
import BlackBoardAISetting from "../../assets/BlackBoardAISetting.png";
import BlackBoardAIInstruction from "../../assets/BlackboardAIInstruction.png";
import BlackBoardAIResponsible from "../../assets/BlackBoardAIResponsible.png";
const ManageVtaPage = () => {
  return (
    <div className="min-h-screen bg-purple-50">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="text-center mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Manage Teaching Assistants
          </h1>
          <div className="text-lg text-gray-700 mb-8 max-w-3xl mx-auto leading-relaxed">
            <p className="mb-4">
              Configure and manage your AI Virtual Tutor to provide
              the best learning experience for your students.
            </p>
            <p className="text-xl font-semibold text-purple-700">
              Monitor performance, update knowledge, and optimize interactions
            </p>
          </div>
          <div className="text-lg text-gray-700 mb-8 max-w-3xl mx-auto leading-relaxed">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Step 1: Set a Welcome Message
            </h2>

            <p className="mb-4">
              This is the first message students will see when they open the
              chat.
            </p>
            <p className="mb-4">
              You can keep it simple (“Hi, how can I help?”) or customize it—for
              example, use it during finals week to remind students about
              deadlines or office hours.
            </p>

            <p className="mb-4">It’s a small touch that sets the tone.</p>
          </div>
          <div className="flex justify-center mb-12">
            <img
              src={BlackBoardAIInstruction}
              alt="CampusMind in Blackboard"
              className="w-full max-w-4xl rounded-2xl shadow-lg"
            />
          </div>

          <div className="text-lg text-gray-700 mb-8 max-w-3xl mx-auto leading-relaxed">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Step 2: Add Conversation Starters
            </h2>

            <p className="mb-4">
              You can add up to 4 quick prompts that students can click on to
              start the conversation.
            </p>
            <p className="mb-4">
              These can be frequently asked questions—like “What’s due this
              week?” or “Where can I find the syllabus?”
            </p>

            <p className="mb-4">
              Or, use them to highlight what CampusMind can help with, so
              students know what to ask.
            </p>
          </div>
        </div>

        <div className="flex justify-center mb-12">
          <img
            src={BlackBoardAIInstruction}
            alt="CampusMind in Blackboard"
            className="w-full max-w-4xl rounded-2xl shadow-lg"
          />
        </div>
        <div className="text-center mb-12">
          <div className="text-lg text-gray-700 mb-8 max-w-3xl mx-auto leading-relaxed">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Step 3: Choose Your Tutor’s Behavior
            </h2>

            <p className="mb-4">
              Decide how your AI Virtual Tutor should respond.
            </p>
            <p className="mb-4">
              Want it to be more guided or exploratory? Just toggle the behavior
              options to match your teaching style.
            </p>
          </div>
        </div>
        <div className="flex justify-center mb-12">
          <img
            src={BlackBoardAISetting}
            alt="CampusMind in Blackboard"
            className="w-full max-w-4xl rounded-2xl shadow-lg"
          />
        </div>
        <div className="text-center mb-12">
          <div className="text-lg text-gray-700 mb-8 max-w-3xl mx-auto leading-relaxed">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Step 4: Set Responsible AI Preferences
            </h2>

            <p className="mb-4">
              This step helps you put the right guardrails in place.
            </p>
            <p className="mb-4">
              You can set limits to ensure students use CampusMind ethically—so
              it supports learning without crossing into answer-sharing or
              misuse.
            </p>
          </div>
        </div>

        <div className="flex justify-center mb-12">
          <img
            src={BlackBoardAIResponsible}
            alt="CampusMind in Blackboard"
            className="w-full max-w-4xl rounded-2xl shadow-lg"
          />
        </div>

        {/* Action Buttons */}
        <div className="text-center mt-12">
          <div className="text-lg text-purple-700 font-bold mb-4">
            <strong>Ready to optimize your Tutor?</strong>
            <br />
            Explore analytics, test performance, or return to the main
            dashboard.
          </div>

          <div className="flex justify-center gap-4 md:gap-8 flex-wrap">
            <Link
              to="/vta-analytics"
              className="bg-purple-700 text-white px-6 py-3 rounded-lg font-medium hover:bg-purple-800 transition-colors duration-200"
            >
              View Analytics
            </Link>
            <Link
              to="/test"
              className="bg-gray-700 text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-800 transition-colors duration-200"
            >
              Test Tutor
            </Link>
            <Link
              to="/"
              className="bg-gray-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-700 transition-colors duration-200"
            >
              Back: Start
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageVtaPage;
